<template>
  <v-card width="100%" height="100%">
    <v-card-title>
      <v-btn text small @click="$router.push({ name: 'TrainingList' })">
        <v-icon left> mdi-arrow-left </v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <!-- Native iframe has its own download functionality -->
      <!-- <v-btn depressed color="primary" @click="download(document)">
        download
      </v-btn> -->
    </v-card-title>

    <v-divider></v-divider>
    <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
    <v-card-text
      class="pa-0"
      id="scollStyle"
      :style="{
        height: isMobile ? 'auto' : '85vh',
        minHeight: isMobile ? '300px' : '700px',
        position: 'relative',
        background: isMobile ? '#ffffff' : '#525659',
        overflowY: 'auto',
      }"
    >
      <!-- Loader while Blob URL is being created/loaded -->
      <div v-if="!pdfUrl && document" class="pa-4 white" style="height: 100%">
        <v-skeleton-loader type="image" height="100%" />
      </div>

      <template v-else-if="pdfUrl">
        <!-- Mobile Optimized View -->
        <div
          v-if="isMobile"
          class="pa-12 text-center d-flex flex-column align-center justify-center"
        >
          <v-icon size="100" color="primary lighten-4">mdi-file-pdf-box</v-icon>
          <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
            Document Preview
          </div>
          <div class="mt-2 grey--text subtitle-1 mb-8">
            Your document is ready. Since you are on a mobile device, please use
            the button below to view it.
          </div>
          <v-btn
            x-large
            color="primary"
            class="text-none px-8 rounded-lg shadow-lg"
            @click="openPdfInNewTab"
          >
            <v-icon left>mdi-eye</v-icon>
            Open Document
          </v-btn>
          <div class="mt-4 grey--text caption">
            The document will open in your device's native PDF viewer.
          </div>
        </div>

        <!-- Desktop Iframe View -->
        <iframe
          v-else
          :src="pdfUrl"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: none; display: block"
          title="Document Viewer"
          loading="lazy"
        ></iframe>
      </template>

      <!-- Empty State -->
      <div
        v-else
        class="pa-12 text-center d-flex flex-column align-center justify-center"
        style="height: 100%"
      >
        <v-icon size="64" color="grey lighten-2">mdi-file-cancel-outline</v-icon>
        <div class="mt-4 grey--text">No document available to display.</div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import FileMixin from "../mixins/FileMixin";
import helpers from "../helpers/helper";
import RouterMixin from "../mixins/RouterMixin.js";

export default {
  name: "FeedbackDocument",
  mixins: [FileMixin, RouterMixin],
  data() {
    return {
      url: process.env.VUE_APP_FILE_API,
      mime: "",
      ext: "",
      pdfUrl: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) =>
      v.$store.dispatch("Feedback/getFeedbackDocument", {
        docNo: v.decodeRoute(to.params.docNo),
        code: v.decodeRoute(to.params.code),
        empNo: v.decodeRoute(to.params.reference),
      })
    );
  },
  computed: {
    document() {
      const docs = this.$store.getters["Feedback/feedbackGetters"](
        "feedbackDocument"
      );
      return docs && docs.length > 0 ? docs[0] : null;
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    document: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.generatePdfUrl(newValue);
        } else {
          this.pdfUrl = null;
        }
      },
    },
  },
  methods: {
    /**
     * Generates a Blob URL from base64 data
     */
    generatePdfUrl(base64Data) {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      try {
        const binaryString = window.atob(base64Data.trim());
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL", e);
        this.pdfUrl = null;
      }
    },

    /**
     * Opens PDF in a new tab - most reliable for mobile devices
     */
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },

    download(item) {
      var a = document.createElement("a");
      this.mime = helpers.detectMimeType(item);
      this.ext = helpers.fileExtension(item);
      a.href = `data:${this.mime};base64,${item}`;
      a.download = `Attachment.${this.ext}`;
      a.click();
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>

<style scoped>
#scollStyle::-webkit-scrollbar {
  width: 8px;
}
#scollStyle::-webkit-scrollbar-track {
  background: #f1f1f1;
}
#scollStyle::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
#scollStyle::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
